import { render } from "./Invitations.vue?vue&type=template&id=f720c46e&scoped=true&ts=true"
import script from "./Invitations.vue?vue&type=script&lang=ts"
export * from "./Invitations.vue?vue&type=script&lang=ts"

import "./Invitations.vue?vue&type=style&index=0&id=f720c46e&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f720c46e"]])

export default __exports__